import { api } from "@/frontend/services/api";
import type { ApiResponse, PaginationRequestDTO } from "@/shared/dto";

export interface PlayerResponseDTO {
  id: string;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  secondLastName?: string | null;
  nickname?: string | null;
  birthDate?: string | null;
  countryId?: string | null;
  imageUrl?: string | null;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface PlayersPaginatedResponseDTO {
  data: PlayerResponseDTO[];
  total: number;
  page: number;
  pageSize: number;
}

export interface PlayerQueryDTO extends PaginationRequestDTO {
  search?: string;
}

export interface CreatePlayerRequest {
  firstName: string;
  lastName: string;
  middleName?: string;
  secondLastName?: string;
  nickname?: string;
  birthDate?: string;
  countryId?: string;
  imageUrl?: string;
}

const BASE_URL = "/players/private";

export const playerService = {
  getPaginate: (params?: Partial<PlayerQueryDTO>) =>
    api.getWithParams<ApiResponse<PlayersPaginatedResponseDTO>>(BASE_URL, params),
  getById: (id: string) =>
    api.get<ApiResponse<PlayerResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreatePlayerRequest) =>
    api.post<ApiResponse<PlayerResponseDTO>>(BASE_URL, data),
  getAll: async (search?: string): Promise<PlayerResponseDTO[]> => {
    const pageSize = 100;
    let page = 1;
    const all: PlayerResponseDTO[] = [];

    while (true) {
      const res = await api.getWithParams<ApiResponse<PlayersPaginatedResponseDTO>>(
        BASE_URL,
        { page, pageSize, search },
      );
      if (!res.success || !res.data) break;

      all.push(...res.data.data);
      if (res.data.data.length < pageSize) break;
      page += 1;
    }

    return all;
  },
};
